// Mirror of server/src/services/investigations/timeline.ts. Brief timeline
// entries have no ids, so overrides (hide / note) are keyed by a content
// hash of date + description. Keep this identical to the server version.
const norm = (s: string) => (s || "").trim().replace(/\s+/g, " ").toLowerCase();

export function timelineEntryKey(t: { date: string; description: string }): string {
  const s = `${norm(t.date)}|${norm(t.description)}`;
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return `b:${h.toString(16).padStart(8, "0")}`;
}

export const callKey = (callId: string) => `call:${callId}`;
export const fileKey = (fileId: string) => `file:${fileId}`;
